export default __webpack_public_path__ + "static/Overpass-VariableFont_wght-141a260be3aff4168e263950762c44db.ttf";